import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as enums from '../enums'

import * as enumValueType from './enum-value-type'
import * as structureValueType from './structure-value-type'

export const DOC = gql`
  ${enumValueType.DOC}
  ${structureValueType.DOC}
  fragment FragmentValueType on ValueType {
    __typename
    ... on IntrinsicValueTypeWrapper {
      intrinsic
    }
    ...FragmentEnumValueType
    ...FragmentStructureValueType
  }
`
export const TRANSFORMER = graphql.transformers.OUT.discriminateOn<
  graphql.schema.FragmentValueTypeFragment,
  ents.core.common.value.types.Type,
  '__typename'
>('__typename', {
  EnumValueType: enumValueType.TRANSFORMER,
  IntrinsicValueTypeWrapper: graphql.transformers.OUT.select(
    'intrinsic',
    enums.intrinsicValueType.TRANSFORMER,
  ),
  StructureValueTypeList: structureValueType.TRANSFORMER,
  StructureValueTypeObject: structureValueType.TRANSFORMER,
  StructureValueTypeTuple: structureValueType.TRANSFORMER,
})
